import React from "react";
import classNames from "classnames";
import { css } from "@linaria/core";

import { colors } from "@ui/Theme";

import useHeaderHeight, {
  PRIMARY_HEADER_HEIGHT_CSS_VARIABLE,
  FAULT_EVENT_SIDE_PANEL_HEIGHT_CSS_VARIABLE,
} from "@ui/Header/useHeaderHeight";
import { color } from "@ui";
import ErrorBoundary from "../../../../../../ErrorBoundary";
import LoadingBoundary from "@ui/LoadingBoundary";

interface Props {
  header: React.ReactNode;
  children: React.ReactNode;
  isFolded: boolean;
}

const SidePanel = ({ isFolded, header, children }: Props) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  useHeaderHeight(headerRef, FAULT_EVENT_SIDE_PANEL_HEIGHT_CSS_VARIABLE);

  return (
    <aside className={classNames(asideContainer, { isFolded })}>
      <header ref={headerRef} className={headerContainer}>
        {header}
      </header>
      <ErrorBoundary>
        <LoadingBoundary>{children}</LoadingBoundary>
      </ErrorBoundary>
    </aside>
  );
};

export default SidePanel;

//#region CSS
const asideContainer = css`
  z-index: 3;
  position: sticky;
  top: calc(var(${PRIMARY_HEADER_HEIGHT_CSS_VARIABLE}));
  height: calc(100vh - var(${PRIMARY_HEADER_HEIGHT_CSS_VARIABLE}));

  background-color: ${colors.hydrogen};

  width: var(--side-bar-width);
  border-left: 1px solid ${colors.titanium200};
  will-change: transform;
  transition: transform var(--section-column-transition-duration)
    var(--section-column-transition-ease);

  overflow-y: auto;
  overscroll-behavior: contain;

  &.isFolded {
    transform: translateX(100%);
  }

  display: flex;
  flex-direction: column;
`;
const headerContainer = css`
  z-index: 2;
  position: sticky;
  top: 0;

  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-rows: repeat(2, max-content);

  background-color: ${colors.hydrogen};

  & > *:nth-child(1),
  & > *:nth-child(2) {
    align-self: center;
    margin: 16px 16px;
  }

  nav {
    border-bottom: 1px solid ${color.titanium100};
    grid-column: 1 / -1;
    grid-row: 2/3;
  }
`;
//#endregion CSS
